module.exports = __webpack_public_path__ + "img/Invasion-BRCA_10X_Section1.32d558ed.png";